// @ts-nocheck
import {
  ArrowRightIcon,
  Bind,
  Box,
  Button,
  Heading,
  Stack,
  StackRow,
  Text,
  signal,
} from "@smoothie-framework/ui";
import { prompts } from "./content";
import { asset, Gutter } from "./shared";

const promptIndex = signal(0);
const promptText = signal("");

if (typeof window !== "undefined") {
  const animatePrompt = () => {
    const prompt = prompts[promptIndex()][1];
    let character = 0;

    const type = () => {
      promptText.set(prompt.slice(0, character));
      character += 1;

      if (character <= prompt.length) {
        window.setTimeout(type, 24);
        return;
      }

      window.setTimeout(erase, 1500);
    };

    const erase = () => {
      character -= 2;
      promptText.set(prompt.slice(0, Math.max(character, 0)));

      if (character > 0) {
        window.setTimeout(erase, 12);
        return;
      }

      promptIndex.update((index) => (index + 1) % prompts.length);
      window.setTimeout(animatePrompt, 280);
    };

    type();
  };

  animatePrompt();
}

export function Hero() {
  return (
    <Stack
      as="section"
      className="hero section-dark"
      background="background"
      id="top"
      minH={{ base: 235, lg: "80vh" }}
      justify="end"
    >
      <img
        className="hero-art hero-art-desktop"
        src={asset("hero-elin.png")}
        alt="Elin Voss in The Invitation"
      />
      <img
        className="hero-art hero-art-mobile"
        src={asset("hero-elin-mobile.png")}
        alt=""
        aria-hidden="true"
      />
      <img
        className="hero-shadow"
        src={asset("hero-shadow.png")}
        alt=""
        aria-hidden="true"
      />
      <img
        className="hero-glow"
        src={asset("hero-glow.png")}
        alt=""
        aria-hidden="true"
      />
      <Gutter className="hero-copy" gap={{ base: 4, md: 6 }} h="full">
        <Stack gap={{ base: 4, md: 6 }} pb={{ lgDown: 16 }}>
          <Heading maxW={160} level={1} textStyle="display">
            Turn your story into an
            <br />
            AI micro-drama series.
          </Heading>
          <Text
            as="p"
            maxW={160}
            textStyle="body"
            color="subtle"
          >
            Zequels is an AI micro-drama studio that turns stories, web novels and
            fanfiction into 80-episode vertical series. Write, direct and produce
            with Amanda, your AI producer.
          </Text>
          <Stack
            as="form"
            className="composer"
            gap={6}
            maxW={160}
            minH={0}
            p={{ base: 5, sm: 6 }}
            onSubmit={(event: any) => {
              event.preventDefault();
              document
                .querySelector("#request")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            <Text className="composer-label" textStyle="label" color="disabled">
              Your story idea
            </Text>
            <Stack
              className="composer-prompt"
              gap={1}
              minH={{ base: 20.25, lg: 13.5 }}
            >
              <Box minH={{ base: 20.25, lg: 13.5 }}>
                <Text
                  className="prompt-text"
                  color="subtle"
                  textStyle="preview-emphasis"
                >
                  <Bind>{promptText}</Bind>
                </Text>
              </Box>
            </Stack>
            <StackRow
              align="center"
              className="composer-action-row"
              justify="end"
              minH={11}
            >
              <Button
                className="composer-submit"
                type="submit"
                size="md"
                variant="primary"
                rightIcon={ArrowRightIcon({ size: "sm" })}
              >
                Generate Series
              </Button>
            </StackRow>
          </Stack>
          <Text className="helper" color="subtle" textStyle="meta">
            Private beta. Request access to generate your series.
          </Text>
        </Stack>
        <Stack as="aside" align="end" mb={{ lg: 18 }} hideBelow="lg">
          <Stack gap={4} pt={6} w={84} borderTopWidth="sm" borderTopStyle="solid" borderTopColor="accentSubtle">
            <Text as="span" textStyle="meta" uppercase color="accentEmphasized">
              Episode 01 / story preview
            </Text>
            <Text as="span" className="caption-title" textStyle="h3">
              The invitation
            </Text>
          </Stack>
        </Stack>
      </Gutter>
    </Stack>
  );
}
